export default __webpack_public_path__ + "static/media/6.2172f5a7.svg";